const SHIPMENT_METHOD = Object.freeze({
  ANTER_AJA    : 'Anter Aja',
  JNE          : 'Jne',
  GRAB_EXPRESS : 'GrabExpress'
})

export default SHIPMENT_METHOD